<div class="width-100 gap-05 flex column">
  @if (summaryCardsData$ | async; as cardsData) { @if (cardsData.response) {
  <app-month-card class="width-100" month="current" [cardData]="cardsData.response.currentMonth" />
  <app-month-card class="width-100" month="next" [cardData]="cardsData.response.nextMonth" />
  } @else {
  <app-month-card class="width-100" month="current" [cardData]="loadingData" />
  <app-month-card class="width-100" month="next" [cardData]="loadingData" />
  } }
</div>
